import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)

Vue.prototype.$alert = function (msg, success) {
    if (success) {
        this.$toast({
            message: msg
        })
    } else {
        this.$toast(msg)
    }
}

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})

Vue.prototype.$clicki = function (action, label, value = 1) {
    try {
        stm_clicki('send', 'event', 'A3', 'PC-' + action, label, value)
    } catch (e) {}
}

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
